import React from 'react';
import './Download.css';

// Salon türleri array'leri
const salonTypes1 = [
  'BERBER', 'KUAFÖR', 'NAIL ART', 'SPA', 'GÜZELLİK SALONU', 'ESTETİK MERKEZİ', 
  'DÖVME STÜDYOSU', 'MASAJ SALONU', 'SOLARYUM', 'PIERCING'
];

const salonTypes2 = [
  'WELLNESS', 'CİLT BAKIMI', 'SOLARYUM', 'PİLATES', 'FITNESS', 'YOGA', 
  'TERAPİ', 'REHABİLİTASYON', 'MEDITASYON', 'AROMATERAPI', 'SAUNA', 
  'TÜRK HAMAMI', 'JAKUZI', 'MASAJ TERAPİSİ', 'REFLEKSOLOJI'
];

const salonTypes3 = [
  'SAÇ TASARIMI', 'MAKYAJ', 'GELİN HAZIRLIĞI', 'PROTEZ TIRNAK', 'KAŞ TASARIMI', 
  'LAZER EPİLASYON', 'MİKROBLADİNG', 'KALICI MAKYAJ', 'CİLT YENILEME', 'NAIL ART'
];

// Sonsuz döngü için yazıları çoğalt
const createInfiniteText = (array, repeatCount = 30) => {
  const text = array.join(' • ');
  return Array(repeatCount).fill(text).join(' • ') + ' • ';
};

const Download = () => {
  return (
    <>
      {/* Police Tape Style Moving Text */}
      <div className="police-tape-bg">
        <div className="tape-line tape-1">
          <div className="tape-content content-1">
            <span>{createInfiniteText(salonTypes1)}</span>
          </div>
        </div>
        
        <div className="tape-line tape-2">
          <div className="tape-content content-2">
            <span>{createInfiniteText(salonTypes2)}</span>
          </div>
        </div>
        
        <div className="tape-line tape-3">
          <div className="tape-content content-3">
            <span>{createInfiniteText(salonTypes3)}</span>
          </div>
        </div>
      </div>
      
      <section id="download" className="download-section">
        <div className="download-container">
          <div className="download-content">
            <div className="download-text">
              <h2 className="download-main-title">
                Hemen <span className="title-highlight">İndirin</span> ve Başlayın!
              </h2>
              <p className="download-main-description">
                Randevu345 ile salon işletmeciliğinde yeni bir dönem başlıyor. 
                Ücretsiz indirin ve 30 gün boyunca tüm özelliklerden faydalanın.
              </p>
              
              <div className="download-feature-list">
                <div className="download-feature-item">
                  <div className="feature-check">✓</div>
                  <span>30 gün ücretsiz deneme</span>
                </div>
                <div className="download-feature-item">
                  <div className="feature-check">✓</div>
                  <span>Kurulum desteği</span>
                </div>
                <div className="download-feature-item">
                  <div className="feature-check">✓</div>
                  <span>7/24 müşteri hizmetleri</span>
                </div>
              </div>
              
              <div className="download-store-buttons">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.randevu345.app" 
                  className="download-store-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/googleplay.svg" alt="Google Play'den İndirin" />
                </a>
                <a 
                  href="https://apps.apple.com/tr/app/randevu345/id6743093049" 
                  className="download-store-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/appstore.svg" alt="App Store'dan İndirin" />
                </a>
              </div>
            </div>
            
            <div className="download-phones">
              <div className="phones-container">
                <img src="/assets/telefon1-min.png" alt="Randevu345 Mobil Uygulama" className="phone-primary" />
                <img src="/assets/telefon2-min.png" alt="Randevu Listesi" className="phone-secondary" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Download; 